import { render, staticRenderFns } from "./ListAttachments.vue?vue&type=template&id=584689c1&scoped=true&"
import script from "./ListAttachments.vue?vue&type=script&lang=ts&"
export * from "./ListAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584689c1",
  null
  
)

export default component.exports